import {
   ADDITIONAL_SEAT_COST,
   BASE_SEAT_COST,
} from '@forwardflow/constants/onboarding.constants'
import { TFubUser } from '@forwardflow/types/onboarding'

export const MAX_SEATS = 50

/** $97 for the first seat, $50 for each one after it. */
export const seatCostFor = (seats: number) =>
   BASE_SEAT_COST + Math.max(0, seats - 1) * ADDITIONAL_SEAT_COST

/** The plan is never asked for: one seat is Solo, more is Team. */
export const planNameFor = (seats: number) => (seats > 1 ? 'Team' : 'Solo')

/** "Just you · Solo $97/mo" or "You + 2 · Team $197/mo". */
export const seatSummary = (seats: number) => {
   const who = seats > 1 ? `You + ${seats - 1}` : 'Just you'
   return `${who} · ${planNameFor(seats)} $${seatCostFor(seats)}/mo`
}

/**
 * Who the signed-in person is in Follow Up Boss: the user with the same
 * email, else the account owner, else the first user. `null` when the list
 * is empty.
 */
export const pickOwner = (
   users: TFubUser[],
   email: string | null | undefined
): TFubUser | null => {
   if (!users.length) return null
   const wanted = (email || '').trim().toLowerCase()
   return (
      (wanted && users.find((u) => (u.email || '').toLowerCase() === wanted)) ||
      users.find((u) => u.isOwner) ||
      users[0]
   )
}

export const fullName = (u: Partial<TFubUser>) =>
   `${u.firstName || ''} ${u.lastName || ''}`.trim() || u.name || u.email || ''
